<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/unidadeMedida"> Cadastro/Produtos e Serviços/Unidades de Medidas </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Unidade de medida *"
              v-model="abreviatura"
              v-uppercase
              :counter="3"
              maxlength="3"
              :rules="[(v) => !!v || 'A Unidade de Medida é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/unidadeMedida" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { enviarUnidadeMedidaAsync } from "../../../services/unidadeMedidaService";
import { mapActions } from "vuex";

export default {
  name: "criarUnidadeMedida",
  data: () => ({
    overlay: false,
    valid: true,
    abreviatura: null,
    descricao: null,
  }),
  methods: {
    ...mapActions("unidadeMedida", ["addUnidadeMedida"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarUnidadeMedidaAsync(
          this.abreviatura,
          this.descricao
        );
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Descupe, falha na operação!", "error");
        } else {
          this.addUnidadeMedida(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/unidadeMedida");
        }
      }
    },
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
